import { createMemo, Show } from 'solid-js';
import { orderStore } from '@store/orders';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';

import LTLQuote from '../ltlQuote/LTLQuote';

type Props = {
  useNewTables: boolean;
  insuranceDeleteChangeTrackingSource?: ChangeTrackingSource;
};

export const LTLInfo = (props: Props) => {
  const quoteId = () => orderStore.quoteId ?? '';

  const ltlLoad = createMemo(() => {
    if (orderStore.activeTab.index >= orderStore.order.loads.length)
      return undefined;

    const current = orderStore.order.loads[orderStore.activeTab.index];
    if (
      current.mode !== 'LTL' ||
      (!props.useNewTables && !(current.quoteId && current.ltlQuote))
    ) {
      return undefined;
    }
    return current;
  });

  return (
    <Show when={ltlLoad()}>
      {(safeLoad) => (
        <LTLQuote
          status={safeLoad().status}
          loadId={safeLoad().id}
          load={safeLoad()}
          quoteId={quoteId()}
          legacyQuoteId={
            safeLoad().ltlQuote?.id == null
              ? undefined
              : String(safeLoad().ltlQuote?.id)
          }
          insuranceDeleteChangeTrackingSource={
            props.insuranceDeleteChangeTrackingSource
          }
        />
      )}
    </Show>
  );
};
